import { NativeCommandEnum } from '~/domain/native/models/commands';
import HybridWebView from '~/domain/native/utils/HybridWebView';
import checkLoggingVar from '~/utils/env-helpers/check-use-logging-variable';

type NativeLogGate = () => boolean;

let nativeLogGate: NativeLogGate = () => false;

/** Sets the check that decides whether log, warn and error calls are forwarded to the MAUI host. */
export const setNativeLogGate = (gate: NativeLogGate) => {
  nativeLogGate = gate;
};

const log = (...messages: any[]) => {
  if (checkLoggingVar()) {
    console.log(...messages);
  }
  logInNative('info', ...messages);
};

const error = (...messages: any[]) => {
  if (checkLoggingVar()) {
    console.error(...messages);
  }
  logInNative('error', ...messages);
};

const warn = (...messages: any[]) => {
  if (checkLoggingVar()) {
    console.warn(...messages);
  }
  logInNative('warn', ...messages);
};

const trace = (...messages: any[]) => {
  if (checkLoggingVar()) {
    console.trace(...messages);
  }
};

const debug = (...messages: any[]) => {
  if (checkLoggingVar()) {
    console.debug(...messages);
  }
};

const logInNative = (level: string, ...messages: any[]) => {
  if (nativeLogGate()) {
    try {
      JSON.stringify(messages);
      HybridWebView.SendInvokeMessageToDotNet(NativeCommandEnum.LogInNative, {
        messages,
        level: level,
      });
    } catch {
      return;
    }
  }
};

export default {
  log,
  debug,
  warn,
  error,
  trace,
};
